module.exports = __webpack_public_path__ + "img/daily-footer.6d66d524.png";